import Vue from 'vue'
import VueRouter from 'vue-router'
import SimpleHub from './views/SimpleHub.vue'
import Event from './views/Event.vue'

Vue.use(VueRouter)

const routes = [
  {
    // If this specific path is matched, load the event view
    path: '/event/:id',
    name: 'event',
    component: Event
  },
  {
    // Default to the hub view
    path: '*',
    name: 'hub',
    component: SimpleHub
  },
]

// Removed `base: process.env.BASE_URL`. `publicPath` is set to a full github path in config
// so all paths generated by the router would have that full path prepended
const router = new VueRouter({
  mode: 'hash',
  // Overriding `base` here only affects router URLs in dev mode *sigh*
  base: process.env.BASE_URL,
  routes,
  scrollBehavior () {
    return false
  }
})

export default router
